var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-slate-100 min-h-screen h-full relative"},[_c('NavigationBarComp',{attrs:{"title":_vm.$attrs?.title,"stuck":true}}),_c('router-view',{staticClass:"pt-12 min-h-fit"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }